module.exports = __webpack_public_path__ + "img/pin2.fc36582f.svg";